<template>
  <div class="file-identity">
    <span class="file-type-icon" :class="kind"><i :class="icon"></i></span>
    <span class="file-identity-text"><strong :title="name">{{ name }}</strong><small>{{ label }}</small></span>
  </div>
</template>

<script>
export default {
  name: 'FileIdentity',
  props: { name: { type: String, default: '' } },
  computed: {
    kind() {
      const ext = this.name.split('.').pop().toLowerCase()
      if (['png', 'jpg', 'jpeg', 'gif', 'svg', 'webp'].includes(ext)) return 'image'
      if (['xls', 'xlsx', 'csv'].includes(ext)) return 'sheet'
      if (['zip', 'rar', '7z', 'tar', 'gz'].includes(ext)) return 'archive'
      if (['mp4', 'mov', 'mp3', 'wav'].includes(ext)) return 'media'
      if (ext === 'pdf') return 'pdf'
      return 'document'
    },
    icon() { return { image: 'el-icon-picture-outline', sheet: 'el-icon-tickets', archive: 'el-icon-box', media: 'el-icon-video-camera', pdf: 'el-icon-document', document: 'el-icon-document' }[this.kind] },
    label() { return { image: '图片', sheet: '表格与数据', archive: '压缩文件', media: '音频 / 视频', pdf: 'PDF 文档', document: '文件' }[this.kind] }
  }
}
</script>
